import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { WaterDiaryAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-water-diary-slot',
    templateUrl: './water-diary-slot.component.html',
    styleUrl: './water-diary-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WaterDiarySlotComponent implements SheetSlotComponentBase {

	action!: WaterDiaryAction;
	value!: string | null;

	@Input('action') set updateAction(action: WaterDiaryAction | null) {
		this.action = action as WaterDiaryAction;
		this.value = this.action.totalConsumed?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}